ixModuleRouting("impactx.landingpage", {
    "/approvalworkflow/:prhId": {
        template: "<ixa-approval-workflow></ixa-approval-workflow>",
        templateUrl: "modules/landingpage/templates/approval-workflow.html",
        controller: "ApprovalWorkflowCtrl",
        controllerAs: "approvalWorkflowCtrl",
        process: "ViewBasket",
        workspace: "shop",
    },
    "/approvalworkflowdemand/:dehId": {
        template: "<ixa-approval-workflow-demand></ixa-approval-workflow-demand>",
        templateUrl: "modules/landingpage/templates/approval-workflow.html",
        controller: "ApprovalWorkflowDemandCtrl",
        controllerAs: "approvalWorkflowCtrl",
        process: "ViewBasket",
        workspace: "shop",
    },
});
